export const validationMessage = (type, number) => {
    if (type === 'min') {
        return "Field cannot be less than " + number + " characters";
    } else if (type === 'max') {
        return "Field cannot be longer than " + number + " characters";
    } else if (type === 'len') {
        return "Field must have exact length of " + number + " characters";
    }
};